// extracted by mini-css-extract-plugin
module.exports = {"pre":"pre--2-7gh","preNoWrap":"preNoWrap--3kOaS"};